import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Input from '../atoms/input';
import Button from '../atoms/button';
import LoadingSpinner from '../atoms/loading';
import inputValidator from '../atoms/input-validator';
import I10n from '../features/i10n';
import ReCAPTCHA from 'react-google-recaptcha';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 0px 10px;
  @media (max-width: 800px) {
    padding: 10px 0px;
  }
`;

const FieldWrapper = styled.div`
  margin-bottom: 10px;
`;

const Title = styled.h3`
  margin: 0 0 10px 0;
  font-size: 20px !important;
  line-height: 20px !important;
  color: #626469;
  font-weight: bold;
`;

const Required = styled.span`
  color: red;
`;

const Hint = styled.span`
  font-size: 10px;
  line-height: 15px;
  color: #333333;
  margin-bottom: 5px;
`;

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

class SaveConfiguration extends React.Component {

  static propTypes = {
    isSaving: PropTypes.bool,
    isWrapperMode: PropTypes.bool,
    onSave: PropTypes.func,
    senderEmail: PropTypes.string,
    senderName: PropTypes.string
  }

  constructor(props) {
    super(props);
    this.state = {
      name: props.senderName || '',
      email: props.senderEmail || '',
      recaptchaToken: null
    }
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateStateIfMounted = (stateToSet) => {
    if (this._isMounted) {
      this.setState(stateToSet);
    }
  }

  verifyCallback = (recaptchaToken) => {
    this.updateStateIfMounted({ recaptchaToken: recaptchaToken });
  }

  expiredCallback = () => {
    this.updateStateIfMounted({ recaptchaToken: null });
  }

  withRequired = label => {
    return (
      <div>
        {label}
        <Required>*</Required>
      </div>
    );
  }

  handleInputValue = (event) => {
    const { name, value } = event.target;
    if (this.state[name] !== value) {
      this.setState({ [name]: value });
    } else {
      return false;
    }
  }

  isFormValid = () =>
    inputValidator().validateFields([
      [this.state.name, inputValidator().validateFieldName],
      [this.state.email, inputValidator().validateFieldEmail]
    ]);

  render = () => {
    return (
      <Container>
        <Title>{I10n.get('save_configuration')}</Title>
        {!this.props.isWrapperMode &&
          <>
            <FieldWrapper>
              <Input
                type="text"
                required
                label={this.withRequired(I10n.get('save_configuration.name.label'))}
                name="name"
                value={this.state.name}
                onChange={this.handleInputValue}
                autoComplete="given-name"
              ></Input>
            </FieldWrapper>

            <FieldWrapper>
              <Input
                type="email"
                required
                label={this.withRequired(I10n.get('save_configuration.email.label'))}
                name="email"
                value={this.state.email}
                onChange={this.handleInputValue}
                autoComplete="email"
              ></Input>
            </FieldWrapper>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={this.verifyCallback}
              onExpired={this.expiredCallback}
            />
            <Hint>{I10n.get('save_configuration.hint')}</Hint>
          </>

        }

        {
          this.props.isSaving ?
            <LoadingWrapper>
              <LoadingSpinner></LoadingSpinner>
            </LoadingWrapper>
            :
            <Button primary
              importance="emphasized"
              disabled={this.props.isWrapperMode ? false : !this.isFormValid() || !this.state.recaptchaToken}
              onClick={() => {
                this.props.onSave(this.state.email, this.state.name, this.state.recaptchaToken);
              }}
            >
              {window.self !== window.top ? I10n.get('menu_save') : I10n.get('save_configuration.send_button')}
            </Button>
        }

      </Container>
    );
  }
}

export default SaveConfiguration;
